<!--
    Created by 程雨喵'mac on 2024/9/2.
    Copyright © 2024年 云柜-金星晖. All rights reserved.
    功能概述：运营模板详情
-->
<style lang="less">
.op-template-detail {
  padding-bottom: @containerGap;
}
</style>

<template>
  <div class="op-template-detail">
    <Form>
      <FormItem
        v-for="(item, i) in inputItems"
        :key="i"
        :label="item.label + ':'"
        :label-width="item.labelWidth"
        :required="item.isRequired"
      >
        <RadioGroup
          v-if="item.tagName === 'Radio'"
          v-model="model[item.key]"
          @on-change="onChangeRadio"
        >
          <Radio
            v-for="(sub, r) in item.data"
            :key="'r-' + r"
            :disabled="!isEdit"
            :label="sub.value"
          >
            <span>{{ sub.label }}</span>
          </Radio>
        </RadioGroup>
        <Input
          v-else
          v-model.trim="model[item.key]"
          :placeholder="item.placeholder"
          :disabled="!isEdit"
          class="display-flex-1"
          @input="checkSubmit"
        />
      </FormItem>
    </Form>
    <!--按功率计费-->
    <template
      v-if="model.h5DeviceOperateModel"
    >
      <v-port-power
        v-if="model.category === 1"
        ref="portPowerRef"
        :is-edit="isEdit"
        :model="model.h5DeviceOperateModel"
      />
      <v-card-money
        v-else-if="model.category === 2"
        ref="cardMoneyRef"
        :is-edit="isEdit"
        :model="model.h5DeviceOperateModel"
      />
      <v-op-params
        v-else-if="model.category === 3"
        ref="opParamsRef"
        :is-edit="isEdit"
        :model="model.h5DeviceOperateModel"
      />
    </template>
  </div>
</template>

<script>
import vPortPower from '@/pages/050__deviceManager/chargingPileList/view/setting/operateSetting/portPower.vue';
import vCardMoney from '@/pages/050__deviceManager/chargingPileList/view/setting/operateSetting/cardMoney.vue';
import vOpParams from '@/pages/050__deviceManager/chargingPileList/view/setting/operateSetting/opParams.vue';
import DeviceOperateModel from '@/pages/050__deviceManager/chargingPileList/model/DeviceOperateModel';
export default {
  components: { vPortPower, vCardMoney, vOpParams },
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputItems: [
        { label: '运营模板名称', labelWidth: 120, placeholder: '请输入运营模版名称', key: 'name', isRequired: true },
        {
          label: '模板类型',
          tagName: 'Radio',
          labelWidth: 120,
          placeholder: '',
          key: 'category',
          isRequired: true,
          data: [
            { value: 1, label: '端口功率设置' },
            { value: 2, label: '刷卡金额设置' },
            { value: 3, label: '运营参数设置' }
          ]
        }
      ],
      orgDataList: []
    };
  },
  created () {
    this.checkSubmit();
  },
  methods: {
    checkSubmit () {
      const item = this.inputItems.find(v => !this.model[v.key]);
      this.$emit('on-change', {
        disabled: !!item,
        msg: item ? (item.label + '不可为空') : ''
      });
    },
    onChangeRadio () {
      this.model.h5DeviceOperateModel = null;
      this.model.h5DeviceOperateModel = new DeviceOperateModel();
      this.checkSubmit();
    },
    // 外部调用
    $checkSubmitDataValid () {
      let refDom = null;
      if (this.model.category === 1) {
        refDom = this.$refs.portPowerRef;
      } else if (this.model.category === 2) {
        refDom = this.$refs.cardMoneyRef;
      } else {
        refDom = this.$refs.opParamsRef;
      }
      if (refDom.$checkSubmit().success) {
        if (this.model.category === 1) {
          return this.model.h5DeviceOperateModel.checkValidPowerSubmit();
        } else if (this.model.category === 2) {
          return this.model.h5DeviceOperateModel.checkValidParameterSubmit(this.model.category);
        }
        return this.model.h5DeviceOperateModel.checkValidOperateParameterSubmit();
      }
      return BaseModel.getValidRes(false);
    }
  }
};
</script>
